/**
 * Chart CSS Utilities
 *
 * Utilities for working with CSS variables in chart components.
 */

/**
 * Sanitizes a string to be safe for use in CSS variable names.
 * Converts spaces and special characters to hyphens.
 *
 * This function must be used consistently across all chart components
 * to ensure CSS variable names match between creation (ChartContainer)
 * and reference (individual chart components).
 *
 * @param key - The original data key that may contain special characters
 * @returns A sanitized string safe for CSS variable names
 *
 * @example
 * sanitizeForCSSVar("Search - NA - Mobile") // returns "search-na-mobile"
 * sanitizeForCSSVar("Intake To Procure - NAMER") // returns "intake-to-procure-namer"
 * sanitizeForCSSVar("DemandGen") // returns "demandgen"
 */
export const sanitizeForCSSVar = (key: string): string => {
  return key.replace(/[^a-zA-Z0-9]/g, '-').replace(/-+/g, '-').toLowerCase();
};
